/* Cambiar de marca conserva los filtros nativos de precio y disponibilidad. */
document.addEventListener('click', function (event) {
  var link = event.target.closest && event.target.closest('a[data-jr2-brand-link]');
  if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
  try {
    var destination = new URL(link.href, window.location.href);
    var existing = new URLSearchParams(window.location.search);
    existing.forEach(function(value, key) {
      if (key === 'sort_by' || key === 'filter.v.availability' || key === 'filter.v.price.gte' || key === 'filter.v.price.lte') {
        destination.searchParams.append(key, value);
      }
    });
    event.preventDefault();
    window.location.assign(destination.toString());
  } catch (e) { /* Original link remains usable */ }
});
